import React from "react";
import { Mail, Phone, MapPin, GraduationCap } from "lucide-react";
import Navbar from "./Navbar";
import { imgSet } from "../lib/img";

const heroImg = imgSet("./Semester_4/2.0.webp");

const HeroSection = ({ mainPage = false }) => {
  return (
    <section className="md:max-h-160 flex items-center justify-center bg-stone-200 relative">
      <Navbar mainPage={mainPage} />
      <div className="grid grid-cols-1 md:grid-cols-2 pt-20 md:pt-0 mx-auto gap-8 w-full">
        <div className="flex md:justify-end justify-start md:pt-0">
          <div className="flex flex-col justify-center max-w-108 pl-3 space-y-4">
            <h1 className="text-5xl font-bold text-gray-800">
              Architecture Portfolio
            </h1>

            <div className="space-y-2 text-lg text-gray-600 mt-2">
              <div className="flex items-center gap-2">
                <GraduationCap className="w-5 h-5 text-gray-700" />
                <span>ETH Architecture Graduate Spring 2025</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-gray-700" />
                <a
                  href="mailto:work@vivienneweber.com"
                  className="hover:underline"
                >
                  work@vivienneweber.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-gray-700" />
                <a href="tel:+41798643595" className="hover:underline">
                  079 864 35 95
                </a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5 text-gray-700" />
                <a
                  href="https://www.google.com/maps/place/Zurich"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Zurich
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="relative w-full max-h-160">
          <img
            src={heroImg.full}
            srcSet={heroImg.srcSet}
            sizes="(min-width: 768px) 50vw, 100vw"
            fetchPriority="high"
            decoding="async"
            alt="Building"
            className="w-full max-h-160 object-cover md:max-h-160 px-3 md:px-0"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
